export const APP_DATA = {
  MANDATORY: 'Please, fill this field',
  CONTRACT_ADDRESS: 'Must be valid Contract Address',
  WALLET: 'Must be a valid wallet address',
  OPENSEA_URL: 'Must be valid Opensea URL',
  MANDATORY_IMAGE: 'The image is mandatory',
  BIG_IMAGE: 'File is too large. Max size is 4mb',
  MANDATORY_SELECT: 'Please, select item',
  MANDATORY_PRIZE: 'Please, select prize',
  ADD_PRIZE: 'Please, add prize',
  PRIZE_REMAINING: 'Please, select prize with remaining count more than 0',
  PASSWORD_DONT_MATCH: 'Passwords do not match. Please, try again',
  DATES_ERROR: 'Close date can`t be before Open date',
  DATES_ERROR_START: 'Start date can`t be after Close date',
  OPEN_DATE_ERROR: 'Open date can`t be before current date',
  CLOSE_DATE_ERROR: 'Close date can`t be before current date',
  EMAIL_ERROR: 'Incorrect email address',
  INCLUDE_DIGIT: 'Must include a digit',
  INCLUDE_LOWER_CASE: 'Must contain a lowercase letter',
  INCLUDE_UPPER_CASE: 'Must contain an uppercase letter',
  MIN_LENGHT: 'Must contain at least 8 characters',
  MIN_LENGHT_1: 'Must contain at least 1 characters',
  MIN_LENGHT_2: 'Must contain at least 2 characters',
  MIN_LENGHT_3: 'Must contain at least 3 characters',
  MAX_LENGHT: 'Must contain 20 characters maximum',
  MAX_LENGHT_10: 'Must contain 10 characters maximum',
  MAX_LENGHT_15: 'Must contain 15 characters maximum',
  MAX_LENGHT_25: 'Must contain 25 characters maximum',
  MAX_LENGHT_26: 'Must contain 26 characters maximum',
  MAX_LENGHT_512: 'Must contain 512 characters maximum',
  MAX_LENGHT_255: 'Must contain 255 characters maximum',
  MAX_LENGHT_200: 'Must contain 200 characters maximum',
  MAX_LENGHT_128: 'Must contain 128 characters maximum',
  MAX_LENGHT_110: 'Must contain 110 characters maximum',
  MAX_LENGHT_150: 'Must contain 150 characters maximum',
  MAX_LENGHT_120: 'Must contain 120 characters maximum',
  MAX_LENGHT_100: 'Must contain 100 characters maximum',
  MAX_LENGHT_80: 'Must contain 80 characters maximum',
  MAX_LENGHT_70: 'Must contain 70 characters maximum',
  MAX_LENGHT_50: 'Must contain 50 characters maximum',
  MAX_LENGHT_52: 'Must contain 52 characters maximum',
  MAX_LENGHT_54: 'Must contain 54 characters maximum',
  MAX_LENGHT_20: 'Must contain 20 characters maximum',
  MAX_LENGHT_30: 'Must contain 30 characters maximum',
  MAX_LENGHT_17: 'Must contain 17 characters maximum',
  MAX_RANGE: 'Max Value must be equal or less than 9999',
  MAX_VALUE: 'Value must be equal or less than ',
  MIN_RANGE: 'Min Value must be greater than 0',
  MIN_VALUE: 'Must be equal or greater than ',
  MAX_VALUE_LONG: 'Max value is ',
  IVALID_VALUE: 'Invalid value ',
  SHOULD_CONTAIN_PLUS: ' Please enter the maximum value as "N+".',
  SPACE_END: 'The name should not end with space',
  INTEGER_VALUE: 'Only unsigned integer numbers are allowed',
  SPECIAL_CHARACTER_EXCLUDE: 'Please, remove unsupported characters',
  SPECIAL_CHARACTERS: 'Must contain a special character: #?!\[\]~`@$%^&\' * -<>(){}|\\/"',
  URL: 'Must be url address',
  DOUBLE_SPACE: 'Must not include double spaces',
  TWO_ANSWERS_ONLY: 'Must contain two answers',
  TWO_ANSWERS: 'At least two answers',
  THREE_ANSWERS: 'At least three answers',
  RANGE_MIN_VALUE_ERROR: 'The Min Value can’t be equal or greater than the Max Value',
  RANGE_INCREMENTAL_VALUE_ERROR: 'The increment can’t be 0 or greater than the difference between Max and Min Values',
  RANGE_INCREMENTAL_ALIQUOT_ERROR:
    'Invalid increment value: sequential adding of an increment to the Min Value should be equal to Max Value',
  WEBSITE_PREFIX_VALIDATOR: 'Must contain only lower case letters, numbers or hyphens',
  DUPLICATE_EMAIL: 'Some of entered emails are duplicated',
  EMAIL_REGEX:
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
  EXIST_ANSWER: 'Answer group with those {answer_count} already exist',
  EXTERNAL: 'External',
  SEARCH_EXTERNAL_EVENTS: 'Please, select date',
  TEXT_VARIABLE: 'To display back-end data in the  iframe, please leave the text inside {} unchanged.',
  MIN_MAX_POINTS_ERROR: 'Max points should be more than min points',
  MIN_POINTS_ERROR: 'Min Points should be less than min points of previous range',
  MAX_POINTS_ERROR: 'Max Points should be less than min points of previous range',
  TIERS_PRIZE_ERROR: 'Prize amount should be less than prize amount of previous tier',
  TIERS_EXACT_POINTS_ERROR: 'Points should be less than points of previous tier',
  ZERO_VALUE_ERROR: 'Value cannot be 0',
  MIN_MAX_POSITION_ERROR: 'Max position should be more than min position',
  MIN_POSITION_ERROR: 'Min position should be more than max position of previous range',
  MAX_POSITION_ERROR: 'Max position should be less than min position of previous range',
  FORBIDDEN_IP: 'This IP Address already exists',
  HEXADECIMAL_VALUE: 'Invalid hexadecimal value',
  AUTORESULT_TRANSLATIONS_PREFIX: 'iframe-v3-autoresulting-answer-',
  DUPLICATE_TEAM: 'Same team can’t be selected for a few groups of 1 game',
  RELATED_CONFLICT: 'Date can’t overlap knockout date',
  RELATED_CONFLICT_KNOCKOUT: 'Date can’t overlap group stage date',
  IMAGE_VALID_FORMAT: 'Image must be of one of types jpeg, jpg, png, svg',
  S3_BUCKET_NAME_PATTERN: 'Must match the pattern /^app\\.hunch-[a-z0-9-]+$/.',
  SHEET_BLOCK: 'Sheet Block',
  SHEET_BLOCK_NAME_MAX_LENGTH: 52,
  EXTERNAL_ID_NOT_UNIQUE: 'Market ID must be unique',
  CONNECT3_FORMAT_REGEX: /^(\d+)x(\d+)$/,
  CONNECT3_MAX_REFRESH: 3,
  MIN_SEARCH_LENGTH: 3,
  TIER_ORDER_DUPLICATE: 'You already have tier with same order',
  CODE_LENGTH_ERROR: 'Minimum code length value is 4 and maximum is 8',
  MAX_USERS_FILE_SIZE_MB: 10
};

export const APP_CONFIG = {
  EXTERNAL_ANSWER_OPTIONS: ['AWAY_TEAM', 'HOME_TEAM'],
  TEAM_STATS_MATCH_LABELS: ['Match 1', 'Match 2', 'Match 3', 'Match 4', 'Match 5']
};

export const TOOLTIP_TEXTS = {
  ADD_QUESTION_FIELDS_REQUIRED: 'All fields should be filled and valid to add question',
  ADD_ROUND_FIELDS_REQUIRED: 'All fields should be filled and valid to add a round',
  AUTORESULTING_NOT_AVAILABLE: 'Autoresulting cannot be used with this question type',
  AVATAR_IMAGE_DIMENSIONS:
    'Dimensions: min 80x80px, recommended 160x160px. Format: JPEG, JPG, PNG, SVG. Max size: 4MB.',
  BONUS_ID_DEFAULT: 'If not filled, default ID used',
  BRACKET_RESULTS_ALL_TABS: 'The results should be selected for all tabs before submitting',
  CHALLENGE_FILL_MANDATORY_FIELDS: 'Fill all mandatory fields in order to publish the challenge',
  CHALLENGE_LANDING_STATUS: 'Only the challenges in the Pending or Active states can be selected for landing',
  CONNECT3_DEFAULT_ONLY_ONE: 'Only one default can be selected',
  CONNECT3_FILL_SHEET_BLOCK_DETAILS: 'Fill in the Sheet Block details above to create a template',
  CONNECT3_SHEET_FILL_ALL_TILES: 'A sheet can be saved only when all tiles are filled',
  CROP_TO_CIRCLE: 'Whether team logos should be in shape of circle on the round card',
  EDIT_QUESTION_FIELDS_REQUIRED: 'All fields should be filled and valid to edit question',
  EDIT_ROUND_FIELDS_REQUIRED: 'All fields should be filled and valid to edit a round',
  IMAGE_SIZE_1280X512: 'We recommend using a 1280px x 512px image resolution. Max image size is 4MB',
  IMAGE_SIZE_128X128: 'We recommend using a 128px x 128px image resolution. Max image size is 4MB',
  IMAGE_SIZE_12X12: 'We recommend using a 12px x 12px image resolution. Max image size is 4MB',
  IMAGE_SIZE_137X142: 'We recommend using a 137px x 142px image resolution. Max image size is 4MB',
  IMAGE_SIZE_14X14: 'We recommend using a 14x14 image resolution. Max image size is 4 MB',
  IMAGE_SIZE_200X200: 'We recommend using a 200px x 200px image resolution. Max image size is 4MB',
  IMAGE_SIZE_240X240: 'We recommend using a 240px x 240px image resolution. Max image size is 4MB',
  IMAGE_SIZE_24X24: 'We recommend using a 24px x 24px image resolution. Max image size is 4MB',
  IMAGE_SIZE_36X36: 'We recommend using a 36px x 36px image resolution. Max image size is 4MB',
  IMAGE_SIZE_80X80: 'We recommend using a 80px x 80px image resolution. Max image size is 4MB',
  IMAGE_SIZE_MIN_1000X262: 'We recommend using a 1000px x 262px image resolution (minimum). Max image size is 4MB',
  LADDER_DEFAULT_ONLY_ONE:
    'Only one ladder can be set as default. This action will deselect the currently selected one.',
  LEADERBOARD_CONFIRM_DATES:
    'Please fill start and end dates to enable this button. Click on this button to load rounds based on start and end dates',
  LEADERBOARD_FILL_ALL_FIELDS: 'Please fill all fields in both tabs to enable this button',
  LEADERBOARD_LOAD_NEW_ROUNDS: 'Please load new rounds to save the leaderboard',
  LEADERBOARD_TIERS_ORDER: 'Please start tiers creation from the highest one and create them in the descending order',
  PRIZE_IMPORTANT: 'The prize will be highlighted with yellow color if it is important',
  ROUND_CLOSE_DATE: 'The time and date the round will close for entries',
  ROUND_CONFIRM_ANSWERS: 'Please ensure you selected the correct answers for all questions as well as the event score',
  ROUND_CORNER_LABEL_TEXT: 'Set a corner label text for this round',
  ROUND_DESCRIPTION: 'Text describing the round, how to play and what can be won',
  ROUND_NAME: 'The title of the game displayed to users',
  ROUND_OPEN_DATE: 'The time and date the round will appear open for entries',
  ROUND_SPORT: 'Select one option that best categorizes the content of the round',
  ROUND_TYPE: 'If the round content is related to sport/politics or other',
  SCORE_MATCH_EVENT: 'Please make sure you selected the same score for both the round event and the score question',
  TRANSLATION_EMPTY_FIELDS_FALLBACK:
    "All empty fields will be filled by non-localized text for all languages. The fields with already provided translations, won't be overridden",
  VENDOR_ADD_VARIANT_OPTIONS: 'Add variant options to select value'
};
